module.exports = __webpack_public_path__ + "static/img/Dion_Prestia_desktop.7a375da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dion_Prestia_desktop.jpg
// module id = EVrf
// module chunks = 0